import styled from '@emotion/styled'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { colors, fonts, zIndex, metrics } from 'component-library/__styling/settings'

interface StyledHeadlineProps {
    isExclusive: boolean
}

export const StyledHeadline = styled('h1')<StyledHeadlineProps>(({ isExclusive, theme }) => ({
    ...breakWords,
    fontSize: calcRem(25),
    fontWeight: 700,
    fontFamily: theme.fonts.publication.headline,
    lineHeight: 1.28,
    background: `linear-gradient(to bottom, ${colors.thewest.westblueTint} 0%, ${colors.thewest.westblue} 100%)`,
    padding: isExclusive ? calcRem(40, 22, 30) : calcRem(35, 22),
    color: colors.white,
    textAlign: 'center',
    width: `calc(100% - ${metrics.thewest.margins.outerMargin * 2}px)`,
    margin: '0 auto',
    boxShadow: `0 15px 34px 0 ${colors.black25}`,
    position: 'relative',
    zIndex: zIndex.thewest.featureHeadline,
    minHeight: calcRem(150),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [breakpoint('md')]: {
        width: '100%',
        minHeight: calcRem(200),
        maxWidth: calcRem(719),
        padding: isExclusive ? calcRem(32, 32, 26) : calcRem(29, 32),
        fontSize: calcRem(38),
        lineHeight: 1.158,
    },
}))

export const StyledHeadlineText = styled('span')({
    maxWidth: calcRem(800),
})

export const StyledFeatureLabel = styled('span')(({ theme }) => ({
    background: colors.white,
    color: theme.sectionValues.primaryColor,
    textTransform: 'uppercase',
    fontSize: calcRem(18),
    fontWeight: 500,
    padding: calcRem(7, 12),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: fonts.thewest.sansSerif,
    boxShadow: `0 8px 18px 0 ${colors.black35}`,
    lineHeight: 1,
    position: 'absolute',
    top: 0,
    left: '50%',
    borderRadius: calcRem(2),
    transform: 'translate(-50%, -50%)',

    [breakpoint('sm')]: {
        fontSize: calcRem(22),
    },

    '& * + *': {
        marginLeft: calcRem(8),
    },
}))
